import React from 'react';
import { getCoordinateSystemLabel, getCoordinateUsageTip } from '../../utils/coordinateTool';

export default function MapUrlParsePanel({
  mapUrl,
  setMapUrl,
  handleMapUrlParse,
  loading,
  mapUrlResult
}) {
  return (
    <div>
      <div style={{ marginBottom: 10 }}>
        <label style={{ display: 'block', marginBottom: 5, fontWeight: 'bold' }}>地图链接</label>
        <textarea
          value={mapUrl}
          onChange={e => setMapUrl(e.target.value)}
          rows={4}
          placeholder={'可粘贴纯链接，或「地址文字+链接」混合内容，例如：\n城东四路220号\n中国, 浙江省, 丽水市, 龙泉市\nhttps://surl.amap.com/xxx'}
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            fontSize: '14px',
            resize: 'vertical',
            fontFamily: 'inherit'
          }}
        />
      </div>
      <button
        onClick={handleMapUrlParse}
        disabled={loading}
        style={{
          padding: '10px 20px',
          background: '#1976d2',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.6 : 1
        }}
      >
        {loading ? '解析中...' : '解析链接'}
      </button>

      {mapUrlResult && (
        <div style={{ marginTop: 20, padding: 15, background: '#f5f5f5', borderRadius: '4px' }}>
          <h4>解析结果</h4>
          {mapUrlResult.error ? (
            <div style={{ color: 'red' }}>{mapUrlResult.error}</div>
          ) : (
            <div>
              <div><strong>来源:</strong> {mapUrlResult.source}</div>
              {mapUrlResult.name && <div><strong>地点:</strong> {mapUrlResult.name}</div>}
              <div><strong>坐标系:</strong> {getCoordinateSystemLabel(mapUrlResult)}</div>
              {(() => {
                const tip = getCoordinateUsageTip(mapUrlResult);
                return tip ? (
                  <div style={{ marginTop: 6, color: '#666', fontSize: 13 }}>{tip}</div>
                ) : null;
              })()}
              {(() => {
                const c = mapUrlResult.coordinates || {};
                const all = mapUrlResult.allCoordinates || {};
                const wgs84 = c.wgs84 || all.wgs84 || (mapUrlResult.system === 'WGS84' ? { lat: c.lat, lng: c.lng } : null);
                const bd09 = c.bd09 || all.bd09;
                return (
                  <>
                    {wgs84 && (
                      <div style={{ marginTop: 8 }}>
                        <strong>WGS84（Mapbox/Locus 落点）:</strong>{' '}
                        {Number(wgs84.lat).toFixed(6)}, {Number(wgs84.lng).toFixed(6)}
                      </div>
                    )}
                    {bd09 && (
                      <div>
                        <strong>BD09（与百度地图对比）:</strong>{' '}
                        {Number(bd09.lat).toFixed(6)}, {Number(bd09.lng).toFixed(6)}
                      </div>
                    )}
                    {!wgs84 && (
                      <>
                        <div><strong>纬度:</strong> {c.lat}</div>
                        <div><strong>经度:</strong> {c.lng}</div>
                      </>
                    )}
                  </>
                );
              })()}
              {mapUrlResult.coordinates.zoom && (
                <div><strong>缩放级别:</strong> {mapUrlResult.coordinates.zoom}</div>
              )}
              <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap' }}>
                <button
                  onClick={() => {
                    let wgs84 = mapUrlResult.coordinates.wgs84;
                    if (!wgs84 && mapUrlResult.system === 'WGS84') wgs84 = mapUrlResult.coordinates;
                    if (!wgs84) { alert('无WGS84坐标'); return; }
                    const text = `${wgs84.lat},${wgs84.lng}`;
                    if (navigator.clipboard) {
                      navigator.clipboard.writeText(text).then(() => {
                        alert('已复制为WGS84坐标（适用于Locus Map/Mapbox等）！');
                      });
                    } else {
                      const textarea = document.createElement('textarea');
                      textarea.value = text;
                      document.body.appendChild(textarea);
                      textarea.select();
                      document.execCommand('copy');
                      document.body.removeChild(textarea);
                      alert('已复制为WGS84坐标（适用于Locus Map/Mapbox等）！');
                    }
                  }}
                  style={{ padding: '5px 10px', background: '#4caf50', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer' }}
                >
                  复制为：WGS84坐标系纬度,经度
                </button>
                <button
                  onClick={() => {
                    const bd09 = { lat: mapUrlResult.coordinates.lat, lng: mapUrlResult.coordinates.lng };
                    const text = `${bd09.lat},${bd09.lng}`;
                    if (navigator.clipboard) {
                      navigator.clipboard.writeText(text).then(() => {
                        alert('已复制为BD09坐标（百度地图原生坐标）！');
                      });
                    } else {
                      const textarea = document.createElement('textarea');
                      textarea.value = text;
                      document.body.appendChild(textarea);
                      textarea.select();
                      document.execCommand('copy');
                      document.body.removeChild(textarea);
                      alert('已复制为BD09坐标（百度地图原生坐标）！');
                    }
                  }}
                  style={{ padding: '5px 10px', background: '#1976d2', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer' }}
                >
                  复制为：BD09坐标系纬度,经度（百度坐标）
                </button>
                <button
                  onClick={() => {
                    let gcj02 = mapUrlResult.coordinates.gcj02;
                    if (!gcj02 && mapUrlResult.system === 'GCJ02') gcj02 = mapUrlResult.coordinates;
                    if (!gcj02) { alert('无GCJ02坐标'); return; }
                    const text = `${gcj02.lat},${gcj02.lng}`;
                    if (navigator.clipboard) {
                      navigator.clipboard.writeText(text).then(() => {
                        alert('已复制为GCJ02坐标（高德/腾讯地图坐标）！');
                      });
                    } else {
                      const textarea = document.createElement('textarea');
                      textarea.value = text;
                      document.body.appendChild(textarea);
                      textarea.select();
                      document.execCommand('copy');
                      document.body.removeChild(textarea);
                      alert('已复制为GCJ02坐标（高德/腾讯地图坐标）！');
                    }
                  }}
                  style={{ padding: '5px 10px', background: '#ff9800', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer' }}
                >
                  复制为：GCJ02坐标系纬度,经度
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
